<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' @click="addWmenu" :loading="btnLoading">新增</el-button>
      <el-button type='primary' @click="setCarfig" :loading="btnLoading">图片设置</el-button>
      <el-button type='danger' @click="delWmenu" :loading="btnLoading">删除</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="container">
      <vgtree ref="xTree" class="vgtree" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vgtree>
      <el-form :model="form" ref="form"  class="content ss-fl" v-if="wmenuform">
        <el-form-item label="序号" :label-width="formLabelWidth">
          <el-input v-model="form.wmenuseq" :maxlength="6" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级" :label-width="formLabelWidth">
          <el-select v-model="form.wmenuparentid" :clearable="true" >
            <el-option v-for="(item, index) in wmenuList" :label="item.wmenuname" :value="item.wmenuid" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.wmenuname" :maxlength="40" show-word-limit auto-complete="off" ></el-input>
        </el-form-item>
        <el-form-item label="路由" :label-width="formLabelWidth">
          <el-input v-model="form.wmenucode" :maxlength="20" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="路由地址" :label-width="formLabelWidth">
          <el-input v-model="form.wmenuurl" :maxlength="255" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="内容显示模式" :label-width="formLabelWidth">
          <el-select v-model="form.wmenushowtype" :clearable="true" >
            <el-option v-for="(item, index) in wmenuShowTypeList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据来源" :label-width="formLabelWidth" v-if="false">

          <el-select v-model="form.wmenudatafrom" :clearable="true" >
            <el-option v-for="(item, index) in wmenuDatafromList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" :label-width="formLabelWidth" vary v-if="+form.wmenushowtype === 5">
          <el-input v-model="form.wmenudatawhere" :maxlength="30" show-word-limit ></el-input>
        </el-form-item>
        <el-form-item label="显示类型" :label-width="formLabelWidth">
          <el-select v-model="form.wmenuflg" :clearable="true" >
            <el-option v-for="(item, index) in wmenuflgList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="悬浮顺序" v-if="form.wmenuflg == '2'" :label-width="formLabelWidth">
          <el-input v-model="form.wmenushowseq" :maxlength="6" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveWmenu">保存</el-button>
          <el-button type="danger" @click="delWmenu">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  import MenuBtn from "../common/menuBtn"
  export default {
    name: 'wmenuIndex',
    data () {
      return {
        cos: this.$route.params.form,
        list: [],
        btnLoading: false,
        wmenuform: false,
        wmenuList: [],
        wmenuShowTypeList: [],
        wmenuDatafromList:[],
        wmenuflgList:[],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'wmenuname', fieldtype: 'C', title: '名称',calculExpr:''}
        ],
        query: {
          cosid: this.$route.params.form.cosid,
          total: 0,
          currPage: 1,
          pageSize: 20
        },
        wmenu: {},
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    activated() {
      this.init()
      this.getWmenuTree()
      this.getWmenuFolderList()
      this.getWmenuShowTypeList()
      this.getwmenuDatafromList()
      this.getwmenuflgList()
    },
    created () {
    },
    mounted () {
    },
    watch: {
      $route() {
      }
    },
    components: {MenuBtn,vgtree},
    methods: {
      init(){
        this.list = []
        this.cos= this.$route.params.form
        this.wmenuform = false
      },
      initform() {
        this.wmenu = {}
        this.form = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      async addWmenu () {
        this.initform()
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.wmenuseq>maxSeq) {
            maxSeq = item.wmenuseq
          }
        })
        maxSeq += 10
        this.form = {
          wmenuid: 0,
          wmenucosid: this.$route.params.form.cosid,
          wmenuseq: maxSeq,
          wmenucode: '',
          wmenuname: '',
          wmenuurl: '',
          wmenushowtype: '',
          wmenudatawhere:''
        }
        this.wmenuform = true
      },
      async getWmenuShowTypeList() {
        this.wmenuShowTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'wmenushowtype'}
        })
      },
      async getwmenuDatafromList() {
        this.wmenuDatafromList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'wmenudatafrom'}
        })
      },
      async getwmenuflgList() {
        this.wmenuflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'wmenuflg'}
        })
      },
      async getWmenuFolderList() {
        this.wmenuList = await request({
          url: '/ywgl/wmenu/getWmenuList',
          method: "get",
          params: {cosid: this.cos.cosid}
        })
        this.wmenuList.splice(0,0,{
          wmenuname: '无',
          wmenuid: 0
        })
      },
      async setCarfig () {
        // console.log(this.wmenu)
        if (!this.wmenu.wmenuid) {
          this.$message.warning('请选择一个网站菜单!')
          return
        }
        this.$router.push({name: 'carfigIndex', params: {form: this.wmenu}})
      },
      async delWmenu () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/wmenu/delWmenu',
            method: "post",
            data: this.form
          })
          console.log(data)
          if (data.issuccess === 1) {
            this.getWmenuTree()
            this.wmenuform = false
            this.$message.success('删除成功！')
          }
        })
      },
      async saveWmenu () {
        await request({
          url: '/ywgl/wmenu/saveWmenu',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getWmenuTree()
        this.wmenuform = false
      },
      async cellClick (row) {
        this.initform()
        this.wmenu = row.row
        this.form = row.row
        this.wmenuform = true
      },
      async getWmenuTree () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/wmenu/getWmenuTree',
          params: {cosid: this.cos.cosid}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'cosIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vgtree {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .vggrid {
      margin-left: 50px;
      width: 800px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
</style>
